export default __webpack_public_path__ + "static/media/A0001.daba79b5.png";